// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-contaier[data-v-1373b81b]{border-radius:20px;position:relative}.modal-contaier .close-btn[data-v-1373b81b]{cursor:pointer;position:absolute;right:12px;top:12px}.modal-contaier h1[data-v-1373b81b],.modal-contaier p[data-v-1373b81b]{color:var(--v-textColor-base)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
